function modalDirective($bbug, $timeout) {
    'ngInject';

    return {
        restrict: 'A',
        scope: true,
        link(scope, elem, attrs) {

            let deregisterWatcher;
            $timeout(
                () => elem.parent().parent().parent().css('z-index', 999999),
                // watch modal height to ensure it does not exceed window height
                deregisterWatcher = scope.$watch(() => {
                    let modal_padding;
                    const height = elem.height();
                    if ($bbug(window).width() >= 769) {
                        modal_padding = 200;
                    } else {
                        modal_padding = 20;
                    }
                    if (height > $bbug(window).height()) {
                        const new_height = $bbug(window).height() - modal_padding;
                        elem.css({
                            height: new_height + 'px',
                            'overflow-y': 'scroll'
                        });
                        return deregisterWatcher();
                    }
                })
            );
        }
    };
}

/***
 * @ngdoc directive
 * @name BB:bbModal
 * @restrict A
 * @scope true
 *
 * @description
 * Use with modal templates to ensure modal height does not exceed window height
 * <div bb-modal></div>
 */
angular
    .module('BB')
    .directive('bbModal', modalDirective);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/modal/modal.directive.js